import { render, staticRenderFns } from "./PachincoView.vue?vue&type=template&id=9b5eb446&"
import script from "./PachincoView.vue?vue&type=script&lang=ts&"
export * from "./PachincoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports